import {
  Slot
} from "../../../chunk-5DWHOSR4.mjs";
import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/SettingsGroup/SettingsGroup.tsx
import { Text } from "../Text/Text.mjs";
import { jsx } from "react/jsx-runtime";
var cls = (...parts) => parts.filter(Boolean).join(" ");
var settingsGroupVariants = cva("buyscout-settings-group", {
  variants: {
    tone: {
      default: "",
      danger: "buyscout-settings-group--tone-danger"
    }
  },
  defaultVariants: {
    tone: "default"
  }
});
function SettingsGroup({ ref, tone, className, ...props }) {
  return /* @__PURE__ */ jsx("section", { ref, className: settingsGroupVariants({ tone, className }), ...props });
}
SettingsGroup.displayName = "SettingsGroup";
function SettingsGroupHeader({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-settings-group__header", className), ...props });
}
SettingsGroupHeader.displayName = "SettingsGroupHeader";
function SettingsGroupTitle({ ref, className, children, ...props }) {
  return /* @__PURE__ */ jsx("h3", { ref, className: cls("buyscout-settings-group__title", className), ...props, children });
}
SettingsGroupTitle.displayName = "SettingsGroupTitle";
function SettingsGroupDescription({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("p", { ref, className: cls("buyscout-settings-group__description", className), ...props });
}
SettingsGroupDescription.displayName = "SettingsGroupDescription";
function SettingsGroupAction({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-settings-group__action", className), ...props });
}
SettingsGroupAction.displayName = "SettingsGroupAction";
function SettingsList({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-settings-list", className), ...props });
}
SettingsList.displayName = "SettingsList";
function SettingsRow({ ref, asChild = false, separator = true, className, ...props }) {
  const Comp = asChild ? Slot : "div";
  return /* @__PURE__ */ jsx(Comp, { ref, className: cls("buyscout-settings-row", className), "data-separator": separator, ...props });
}
SettingsRow.displayName = "SettingsRow";
function SettingsRowLeading({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-settings-row__leading", className), ...props });
}
SettingsRowLeading.displayName = "SettingsRowLeading";
function SettingsRowContent({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-settings-row__content", className), ...props });
}
SettingsRowContent.displayName = "SettingsRowContent";
function SettingsRowTitle({ className, ...props }) {
  return /* @__PURE__ */ jsx(Text, { variant: "body", as: "div", className: cls("buyscout-settings-row__title", className), ...props });
}
SettingsRowTitle.displayName = "SettingsRowTitle";
function SettingsRowDescription({ className, ...props }) {
  return /* @__PURE__ */ jsx(Text, { variant: "caption", as: "div", className: cls("buyscout-settings-row__description", className), ...props });
}
SettingsRowDescription.displayName = "SettingsRowDescription";
function SettingsRowTrailing({ ref, width = "default", className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-settings-row__trailing", className), "data-width": width, ...props });
}
SettingsRowTrailing.displayName = "SettingsRowTrailing";
export {
  SettingsGroup,
  SettingsGroupAction,
  SettingsGroupDescription,
  SettingsGroupHeader,
  SettingsGroupTitle,
  SettingsList,
  SettingsRow,
  SettingsRowContent,
  SettingsRowDescription,
  SettingsRowLeading,
  SettingsRowTitle,
  SettingsRowTrailing
};
//# sourceMappingURL=SettingsGroup.mjs.map